import myaxios from "@/utils/myaxios";

// 请求时通过token验证时，需要设置headers中的'Authorization'属性，值为'JWT ' + token。（JWT后有个空格）
export default{
    getList(urls){
        const promise1 = myaxios({
            method: 'get',
            headers: {'Authorization': 'JWT ' + localStorage.getItem('token') },
            url: urls,
        })
        return promise1;
    },
    getListP(urls, params){
        const promise1 = myaxios({
            method: 'get',
            headers: {'Authorization': 'JWT ' + localStorage.getItem('token') },
            url: urls,
            params: params,
        })
        return promise1;
    }
}